var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDna(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    height: "21px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 503.5c-.3 4.6 3.3 8.5 8 8.5h16.1c4.2 0 7.7-3.1 8-7.3.4-5.6 1.4-14.1 3.5-24.7h312.6c2.2 10.7 3.3 19.3 3.7 24.8.4 4.1 3.8 7.2 8 7.2H376c4.7 0 8.3-3.9 8-8.5-2.3-31.5-18.5-142-132.2-227.9-9.3 6.3-19.2 12.4-29.6 18.3 26 18.4 46.6 38.2 63.2 58.2H97.7c24.1-28.8 57-57.5 102-82C360.9 182.3 381.4 44.4 384 8.5c.3-4.6-3.3-8.5-8-8.5h-16.1c-4.2 0-7.7 3.1-8 7.3-.4 5.6-1.4 14.2-3.5 24.8H35.8c-2.2-10.7-3.2-19.3-3.7-24.8-.4-4.1-3.8-7.2-8-7.2L8 0C3.4 0-.3 3.9 0 8.5c2.5 34 21.7 159.5 161 247.3C21.3 343.6 2.5 469.5 0 503.5zM340 64c-6.3 19.2-15.9 41.2-30.4 64H75c-14.4-22.9-24.1-44.8-30.5-64H340zM192 237.4c-40.7-23.3-71.2-50.2-93.8-77.4h188.1c-22.7 27.1-53.4 53.9-94.3 77.4zM44 448c6.3-19.2 15.9-41.1 30.4-64h234.5c14.5 22.9 24.2 44.9 30.6 64H44z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDna);
export default __webpack_public_path__ + "static/media/dna.8e89ec5a.svg";
export { ForwardRef as ReactComponent };